export const titleCase = (str?: Nullable<string>) =>
  str
    ?.split(' ')
    .reduce((s, c) => s + '' + (c.charAt(0).toUpperCase() + c.slice(1).toLowerCase() + ' '), '')
    .trim() ?? ''
